module.exports = __webpack_public_path__ + "img/arrow-down-square.c9b1f919.svg";